<template>
    <div class="tables-basic">

        <div v-if="loading" class="page-loading-container">
            <b-spinner label="Loading..." ></b-spinner>
        </div>
        <div v-else-if="crawlVersion < 1">
            <span style="color:gray">This report was generated with an older version of pagewatch.</span>
        </div>
        <div v-else>
            <h1 class="page-title"> Change History Across All Pages </h1>
            <change-viewer :options="changeViewer"></change-viewer>
        <Widget  class="">
            <div class="table-responsive">
                <div v-if="trends.heatMap.categories.length > 0" :key="plotKey">
                    <heat-graph :pad="0" :height="94" :options="trends.heatMap"></heat-graph>
                </div>
                <p></p>

                <div v-if="changedPages.filter( (p)=> p.type === 17).length > 0">
                    <b-alert show variant="info"><b>{{chosenCrawl.started_at | moment('D MMM,  h:mm a')}}:</b>  {{changedPages.filter( (p)=> p.type === 17).length}} Updated Pages Detected</b-alert>

                    <b-container >
                        <b-row>
                            <b-col xl="9">
                                <div class="bg-light p-3" style="min-height: 408px;">
                                    <b-dropdown size="sm" id="dropdown-left" :text="selectedDevice.title" class="m-2" style="float:right">
                                        <b-dropdown-item v-for="device in devices" href="#" @click="setDevice(device)">{{device.title}}</b-dropdown-item>
                                    </b-dropdown>
                                    <a :href="selectedPage.url" target="_blank">{{selectedPage.url}}</a><div>
                                    <small> <router-link :to="{ name: 'ExplorePageDetails', query: {url: selectedPage.path} }" title="Page Details"><i class="fa fa-eye"></i> Page Details</router-link></small>
                                </div><br>
                                <b-container>
                                    <b-row>
                                        <b-col cols="12" md="6" class="d-none d-lg-block">
                                            <div style="margin:4px auto;width:fit-content;">
                                            <b-badge variant="info"> {{selectedPage.parentCrawlDate | moment('D MMM,  h:mm a')}}</b-badge>
                                            </div>
                                            <div style="position:absolute;left:100%;top:0px;"><i class="fa fa-arrow-right text-info"></i> </div>
                                            <div style="position:absolute;left:100%;top:45%;"><i class="fa fa-arrow-right text-info"></i> </div>
                                            <div style="position:absolute;left:100%;top:90%;"><i class="fa fa-arrow-right text-info"></i> </div>
                                            <div style="position:relative">
                                                <a  @click="showComparison(selectedPage.id, selectedPage.path)">
                                                <div :class="{'active-animatioon': true, 'animation-active': boxesBefore.length < animationThreshold, changeBox: true, changeBoxNew: change.type === 'new', changeBoxText: change.type === 'text'}" v-for="change in boxesBefore" :style="{ position: 'absolute', top: `${change.y}px`, left: `${change.x}px`, width: `${change.width}px`, height: `${change.height}px`}">
                                                </div>
                                                <vue-load-image>
                                                    <img slot="image"  :height="imageHeight" :width="imageWidth"  :src="imageBefore" class="preview-image">
                                                    <div slot="preloader" class="image-loading-container" :style="{width:imageWidth + 'px', height:imageHeight + 'px'}"><div><b-spinner label="Loading..." ></b-spinner><br>Loading.. </div></div>
                                                    <div slot="error" class="">
                                                        <h4>Cannot Load Image.</h4>
                                                        <i class="fa fa-warning"></i>
                                                    </div>
                                                </vue-load-image>
                                                </a>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <div style="margin:4px auto;width:fit-content;">
                                                <b-badge variant="info"> {{selectedPage.crawlDate | moment('D MMM,  h:mm a')}}</b-badge>
                                            </div>
                                            <div style="position:relative">
                                                <a  @click="showComparison(selectedPage.id, selectedPage.path)">
                                                    <div  :class="{'active-animatioon': true, 'animation-active': boxesAfter.length < animationThreshold, changeBox: true, changeBoxNew: change.type === 'new', changeBoxText: change.type === 'text'}" v-for="change in boxesAfter" :style="{ position: 'absolute', top: `${change.y}px`, left: `${change.x}px`, width: `${change.width}px`, height: `${change.height}px`}">
                                                    </div>
                                                    <vue-load-image>
                                                        <img slot="image" :height="imageHeight" :width="imageWidth"  :src="imageAfter" class="preview-image">
                                                        <div slot="preloader" class="image-loading-container" :style="{width:imageWidth + 'px', height:imageHeight + 'px'}"><div><b-spinner label="Loading..." ></b-spinner><br>Loading.. </div></div>
                                                        <div slot="error" class="">
                                                            <h4>Cannot Load Image.</h4>
                                                            <i class="fa fa-warning"></i>
                                                        </div>
                                                    </vue-load-image>
                                                </a>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                                </div>
                            </b-col>
                            <b-col xl="3">
                   <h5>{{changedPages.filter( (p)=> p.type === 17).length}} Changed Pages</h5>
                                <b-nav variant="info" vertical class="nav-hover" pills small style="padding-top:10px;padding-left:4px;border-left:1px solid #80808066">
                                    <b-nav-item :active="page.path === selectedPage.path" :to="{name: 'ChangesPage', query:{c: chosenCrawl.id, p: page.path || '', page:pageOffset}}" v-for="page in changedPagesVisible.filter( (p)=> p.type === 17)">{{page.urlTitle}}</b-nav-item>

                                </b-nav>
                                <b-button v-if="pageOffset > 0" size="sm" style="float:left" :to="{query:{c: chosenCrawl.id, p: selectedPage.path || '', page:pageOffset-1}}"><i class="fa fa-arrow-left"></i></b-button>
                                <b-button v-if="(pageOffset+1) * perPage < changedPages.filter( (p)=> p.type === 17).length" size="sm" style="float:right;" :to="{query:{c: chosenCrawl.id, p: selectedPage.path || '', page:pageOffset+1}}"><i class="fa fa-arrow-right"></i></b-button>

                            </b-col>
                        </b-row>
                    </b-container>
                </div>
                <div v-else>
                    <b-alert show variant="info"><b>{{chosenCrawl.started_at | moment('D MMM,  h:mm a')}}:</b>  No Updated Pages Detected</b-alert>

                </div>

            </div>
        </Widget>

    </div>
    </div>
</template>

<script>
  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";
  import VueLoadImage from 'vue-load-image'
  import { mapState } from "vuex";
  import HeatGraph from "@/components/TrendGraph/HeatGraph";
  import ChangeViewer from "@/components/ChangeViewer/ChangeViewer";


  export default {
    name: 'Subscriptions',
    components: { Widget, DemoNotice, ChangeViewer, 'vue-load-image': VueLoadImage, HeatGraph },
    data(){
      return {
        plotKey: 0,
        animationThreshold: 20,
        changeViewer: {
          show: false,
          page: 0,
          path: ''
        },
        selectedPage: {
          id: 0
        },
        trends:{
          history:[],
          heatMap:{
            series:[
              {name: 'Visual', data:[]},
            ],
            categories: []
          }
        },
        devices: [],
        selectedDevice: {id: 'chrome', title: 'Desktop (1366x768)', width: 1366, height: 768},
        crawlData: [],
        crawlVersion: null,
        loading: true,
        currentPage: 1,
        numberOfPages: 1,
        visualChanges:[],
        imageBefore: '',
        imageAfter: '',
        imageWidth: 800,
        imageHeight: 500,
        boxesBefore: [],
        boxesAfter:[],
        visualChangesParent:[],
        subscriptionActive: true,
        screenshotWidth: 280,
        screenshotUrl: '',
        categories:[],
        screenshots:{
          current:{
            width: 280,
            url: '',
            height:0,
          },
          parent: {
            width: 280,
            url: '',
            height: 0,
          },
        },
        selectedSeriesIndex: 0,
        chosenCrawl: {},
        parentPage: {
          id: 0,
          crawl_date: 0,
        },
        parentCrawlId: null,
        diffsData: [],
        changedPages: [],
        changedPagesVisible: [],
        pageOffset: 0,
        perPage: 25,
        newPages: [],
        totalChanges: 0,
        parentRender: {},
        chartDrawn: false,
        dataLoaded:{
          pages: 0,
          pageDiff: 0,
          crawls: 0,
        },
        page: {},
      }
    },
    apollo: {
      changes: {
        query(){
          return gql`query getChanges($pageId: Int!, $device: String!){
              changes:websites_crawledpage(where: {id: {_eq: $pageId}}){
                id
                path
                url
                crawl_id
                crawl_date
                websites_devicerenders(where: {device_id: {_eq: $device}}){
                    id
                    screenshots
                }
                websites_diffs(where: {type: {_eq: 17}, websites_devicerender:{device_id:{_eq: $device}}}){
                    id
                    ratio
                    type
                    data
                }
                parent_page{
                    id
                    path
                    url
                    crawl_id
                    crawl_date
                    websites_devicerenders(where: {device_id: {_eq: $device}}){
                        id
                        screenshots
                    }
                    websites_diffs(where: {type: {_eq: 17}, websites_devicerender:{device_id:{_eq: $device}}}){
                        id
                        ratio
                        type
                        data
                    }
                }
              }
        }`
        },
        variables(){
          return {
            pageId: this.selectedPage.id,
            device: this.selectedDevice.id,
          }
        },
        result(data) {

          let page = data.data.changes[0];
          let parentPage = data.data.changes[0].parent_page;

          if (!parentPage){
            this.boxesBefore = [];
            this.boxesAfter = [];
            this.page.url = page.url;
            this.page.dateBefore = page.crawl_date;
            this.page.dateAfter = '';
            this.page.path = page.path;

            let originalWidth = page.websites_devicerenders[0].screenshots.full.screenshot.width;
            let height1 = page.websites_devicerenders[0].screenshots.full.screenshot.height;

            let ratio = Math.min(originalWidth, 280) / originalWidth;
            this.imageWidth = originalWidth * ratio;
            this.imageHeight = height1 * ratio;

            let transform = `?tr=w-${this.imageWidth},h-${this.imageHeight},cm-pad_resize,bg-F3F3F3,fo-top`;
            this.imageBefore = page.websites_devicerenders[0].screenshots.full.screenshot.url+transform;
            this.imageAfter = this.imageBefore;
            return
          }

          this.page.url = page.url;
          this.page.dateBefore = parentPage.crawl_date;
          this.page.dateAfter = page.crawl_date;
          this.page.path = page.path;

          let originalWidth = page.websites_devicerenders[0].screenshots.full.screenshot.width;
          let height1 = page.websites_devicerenders[0].screenshots.full.screenshot.height;
          let height2 = parentPage.websites_devicerenders[0].screenshots.full.screenshot.height;

          let ratio = Math.min(originalWidth, 280) / originalWidth;
          this.imageWidth = originalWidth * ratio;
          this.imageHeight = Math.max(height1, height2) * ratio;

          let transform = `?tr=w-${this.imageWidth},h-${this.imageHeight},cm-pad_resize,bg-F3F3F3,fo-top`;
          this.imageBefore = parentPage.websites_devicerenders[0].screenshots.full.screenshot.url+transform;
          this.imageAfter = page.websites_devicerenders[0].screenshots.full.screenshot.url+transform;

          this.boxesBefore = [];
          this.boxesAfter = [];
          for (let diff of page.websites_diffs){

            for (let entry of diff.data){
              this.boxesAfter.push({
                select:entry.box.select,
                x: Math.round(entry.box.x * this.imageWidth / originalWidth),
                y: Math.round(entry.box.y * this.imageWidth / originalWidth),
                width: Math.round(entry.box.width * this.imageWidth / originalWidth),
                height: Math.round(entry.box.height * this.imageWidth / originalWidth),
                level: entry.box.level,
                type: entry.type,
              });
              if (!(entry.parent && entry.parent.level)){
                continue;
              }
              this.boxesBefore.push({
                select:entry.parent.select,
                x: Math.round(entry.parent.x * this.imageWidth / originalWidth),
                y: Math.round(entry.parent.y * this.imageWidth / originalWidth),
                width: Math.round(entry.parent.width * this.imageWidth / originalWidth),
                height: Math.round(entry.parent.height * this.imageWidth / originalWidth),
                level: entry.parent.level,
                type: entry.type,
              })
            }
          }
        },
        skip() {
          return !(this.chosenCrawl.id && this.selectedDevice.id && this.selectedPage.id) || (this.dataLoaded.pageDiff && this.scanStatus.completed)
        }
      },
      $subscribe: {
        pages: {
          query() {
            return gql`subscription {
                pages:websites_diff(where:{websites_crawl: {id: {_eq: ${this.chosenCrawl.id}}}, websites_devicerender: {device_id: {_eq: "${this.selectedDevice.id}"}}}){
                    id
                    type
                    data
                    ratio
                    websites_crawledpage{
                      id
                      crawl_date
                      parent_page_id
                      parent_page{
                        id
                        crawl_date
                      }
                      url
                      path
                      title
                    }
                    websites_devicerender{
                      id
                      device_id
                      screenshots
                    }
                  }
    }`
          },
          result(data) {
            this.setChangedPages(data.data.pages);
          },
          skip() {
            return !(this.chosenCrawl.id && this.selectedDevice.id) || (this.dataLoaded.pages && this.scanStatus.completed)
          }
        },
        crawls: {
          query() {
            return gql`subscription GetCrawls($siteId: Int) {
                      crawls:websites_crawl(where: {website_id: {_eq: $siteId}}, order_by:{completed_at: desc}, limit: 30){
                            id
                            parent_crawl_id
                            started_at
                            websites_diffs{
                              id
                              type
                              ratio
                              websites_crawledpage{
                                  id
                                  level
                                  url
                                  path
                                }
                              websites_devicerender{
                                  id
                                  device_id
                              }
                            }
                      }
              }`
          },
          variables() {
            return {
              siteId: this.activeSite.id
            }
          },
          skip() {
            return !(this.activeSite) || (this.dataLoaded.crawls && this.scanStatus.completed)
          },
          result(data) {
            let chosenCrawlIndex = data.data.crawls.findIndex((v) => v && v.id == this.$route.query.c);
            if (chosenCrawlIndex < 0) {
              chosenCrawlIndex = 0;
            }
            this.devices = this.activeSite.devices;

            this.chosenCrawl = {
              id: data.data.crawls[chosenCrawlIndex].id,
              started_at: data.data.crawls[chosenCrawlIndex].started_at,
            };
            // this.parentCrawlId = data.data.crawls[chosenCrawlIndex].parent_crawl_id;

            this.loading = false;
            this.crawlVersion = 2;

            this.crawlData = data.data.crawls;
            // this.crawlData.reverse();
            window.crawlData = this.crawlData;
            this.drawCrawlData();
          },
        }
      }
    },
    computed: {
      ...mapState({ activeSite: "activeSite", scanStatus: "scanStatus", user: "user" }),
      chartSeries: function(){
        return this.chart.series;
      },
      chartOptions: function(){
        return this.chart.options;
      },
      filteredPages: function(){
        let allowedTypes = [17];
        if (this.$route.params.changeType === 'copy'){
          allowedTypes = [18];
        }
        return this.changedPages.filter((p)=> allowedTypes.indexOf(p.type) >= 0)
      },
      filteredVisualChanges: function(){
        let allowedTypes = ['text', 'new', 'difference'];
        if (this.$route.params.changeType === 'copy'){
          allowedTypes = ['text'];
        }
        return this.visualChanges.filter((p)=> allowedTypes.indexOf(p.type) >= 0)
      },
      filteredVisualChangesParent: function(){
        let allowedTypes = ['text', 'new', 'difference'];
        if (this.$route.params.changeType === 'copy'){
          allowedTypes = ['text'];
        }
        return this.visualChangesParent.filter((p)=> allowedTypes.indexOf(p.type) >= 0)
      }
    },
    methods: {
      showComparison(page_id, path){
        this.changeViewer.path = path;
        this.changeViewer.page = page_id;
        this.changeViewer.device = this.selectedDevice.id;
        this.changeViewer.show = true;
      },
      drawCrawlData(){
        let series = [];

        this.diffsData = [];
        this.newPages = [];
        this.categories = [];
      //  let count = 0;
        this.selectedSeriesIndex = 0;

        this.trends.heatMap = {
          series: [
              {name: 'Changed Pages', data:[], params: []},
            ],
          categories:[],
          categoryParams:[]
        };

        for (let i=this.crawlData.length-1; i>=0; i--){
            let entry = this.crawlData[i];
        //    count += 1;
            if (entry.id === this.chosenCrawl.id){
                this.selectedSeriesIndex = i;
                for (let d of entry.websites_diffs){
                  if (d.type === 1) {
                    this.newPages.push({
                      url: d.websites_crawledpage.url,
                      path: d.websites_crawledpage.path,
                      level: d.websites_crawledpage.level,
                    })
                  }
                }
            }
            this.diffsData.push({
                crawl: entry.id,
                started_at: entry.started_at,
                parent: entry.parent_crawl_id,
                diffs: entry.websites_diffs
            });
            this.trends.heatMap.series[0].data.push(entry.websites_diffs.filter((v) => {
              return (v.websites_devicerender && v.websites_devicerender.device_id === this.selectedDevice.id && v.type === 17)
            }).length)
            this.trends.heatMap.categoryParams.push(entry.id);
            this.trends.heatMap.categories.push(new Date(entry.started_at).getTime());
        }
        this.plotKey += 1;
      },
      setChangedPages(pages){
        this.changedPages = [];
        this.totalChanges = 0;
        for (let page of pages){
          if (page.websites_devicerender && page.websites_devicerender.device_id === this.selectedDevice.id) {
            this.totalChanges += page.data.length;
            this.changedPages.push({
              id: page.websites_crawledpage.id,
              crawlDate: page.websites_crawledpage.crawl_date,
              parentCrawlDate: (page.websites_crawledpage.parent_page || {}).crawl_date,
              parentPageId: page.websites_crawledpage.parent_page_id,
              type: page.type,
              boxCount: page.data.length,
              url: page.websites_crawledpage.url,
              path: page.websites_crawledpage.path,
              title: page.websites_crawledpage.title,
              urlTitle: '/' + (page.websites_crawledpage.path || ' [Homepage]')
            })
          }
        }
        this.changedPages.sort( (a,b) => { return b.boxCount - a.boxCount});

        this.paginatePages();

        let wantedPath = this.$route.query.p || this.selectedPage.path;
        this.selectedPage = this.changedPages.find( (p)=>{return p.path === wantedPath}) || {};

        if (!this.selectedPage.id){
          this.selectedPage = this.changedPages[0] || {};
        }

      },
      paginatePages(){
        this.changedPagesVisible = this.changedPages.slice(this.pageOffset * this.perPage, this.perPage + this.pageOffset * this.perPage);
      },
      setDevice(device) {
        this.selectedDevice = device;
        this.chartDrawn = false;
        this.drawCrawlData()
      },
      linkGen(hash) {
        if (!hash){
          hash = '';
        }
        return (pageNum) =>{
          return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
        };
      },
    },
    watch: {
      'activeSite': function () {
        this.dataLoaded = {
          pages: 0,
          pageDiff: 0,
          crawls: 0,
        };
      }
    },
    mounted() {
      this.chartDrawn = false;
      this.$root.$on('scan_completed',  () => {
        if (this.$apollo.queries.crawls) {
          this.$apollo.queries.crawls.refetch();
        }
      });

    },
    created() {
      this.$watch("$route",() => {
        this.currentPage = this.$route.query.page || 1;
        if (this.$route.query.c) {
          this.chosenCrawl.id = this.$route.query.c;
          this.chosenCrawl.started_at = (this.crawlData.find( (c) => c.id === this.chosenCrawl.id) || {}).started_at;
          // this.parentCrawlId = (this.crawlData.find( (c) => c.id === this.chosenCrawl.id) || {}).parent_crawl_id;
        }
        if (this.$route.query.p !== undefined){
          this.selectedPage = this.changedPages.find( (p)=>{return p.path === this.$route.query.p});
        }
        if (!this.selectedPage){
          this.selectedPage = this.changedPages[0] || {};
        }
        this.pageOffset = 0;
        if (this.$route.query.page !== undefined){
          this.pageOffset = parseInt(this.$route.query.page, 10);
          this.paginatePages()
        }
        this.subscriptionActive = true;
        }, {
        immediate: true
      });
    }
  };
</script>

<style lang="scss">
    .report-link-entry{
        max-width:400px;
        overflow:auto;
    }
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
        border-color:blue;
    }
    .changeBox{
        /*background-color: rgba(255, 0, 0, 0.09);*/
        border: 1px solid red;
    }



    .active-animatioon {
        background-image: linear-gradient(90deg, red 50%, transparent 50%), linear-gradient(90deg, red 50%, transparent 50%), linear-gradient(0deg, red 50%, transparent 50%), linear-gradient(0deg, red 50%, transparent 50%);
        background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
        background-size: 4px 2px, 4px 2px, 2px 4px, 2px 4px;
        background-position: left top, right bottom, left bottom, right   top;
        /*animation: border-dance 1.4s infinite linear;*/
        background-color:#ff000042;
    }
    .changeBoxNew{
        border: 1px solid blue;
        background-image: linear-gradient(90deg, blue 50%, transparent 50%), linear-gradient(90deg, blue 50%, transparent 50%), linear-gradient(0deg, blue 50%, transparent 50%), linear-gradient(0deg, blue 50%, transparent 50%);
        background-color: rgba(99, 178, 255, 0.26);
    }
    .changeBoxText{
        border: 1px solid orange;
        background-image: linear-gradient(90deg, orange 50%, transparent 50%), linear-gradient(90deg, orange 50%, transparent 50%), linear-gradient(0deg, orange 50%, transparent 50%), linear-gradient(0deg, orange 50%, transparent 50%);
    }
    .active-animatioon-small {
        background-image: linear-gradient(90deg, red 50%, transparent 50%), linear-gradient(90deg, red 50%, transparent 50%), linear-gradient(0deg, red 50%, transparent 50%), linear-gradient(0deg, red 50%, transparent 50%);
        background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
        background-size: 15px 3px, 15px 3px, 3px 15px, 3px 15px;
        background-position: left top, right bottom, left bottom, right   top;
        /*animation: border-dance 1s infinite linear;*/
    }
    .animation-active{
        animation: border-dance 1s infinite linear;
    }
    @keyframes border-dance {
        0% {
            background-position: left top, right bottom, left bottom, right   top;
        }
        100% {
            background-position: left 15px top, right 15px bottom , left bottom 15px , right   top 15px;
        }
    }
    .diff_neutral{
        color:gray;
    }
    .diff_removal{
        color:red;
    }
    .diff_insert{
        color:green;
    }

    .visual-pages-list{
        font-size:90%;
        border:1px solid rgba(128, 128, 128, 0.17);
        border-radius:4px;
    }

    .preview-image{
        outline:1px solid rgba(128, 128, 128, 0.33);
        border-radius:4px;
    }
    .visual-changes-box{
        margin:4px auto;
        border:1px solid #8080803b;
        width:fit-content;
        padding:4px;
        border-radius:4px;
    }
    span.circle-box{
        padding-top:3px;
        margin:0;
        margin-left:12px;
    }
    div.tab-card{
        background-color:white;
        padding:8px 20px 0px 20px;
    }
    ul.widget-tab-card{
        padding-bottom:0;
        border-bottom:0;
        overflow-y:hidden;
    }

</style>
